import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DxValidationGroupComponent, DxValidationGroupModule } from 'devextreme-angular/ui/validation-group';
import { ToastrService } from 'ngx-toastr';
import { AnalyticsService } from '../../shared/analytics.service';
import { RegistrationSharedService } from '../registration-shared.service';
import { ICountry } from '@pedix-workspace/angular-ui-form';
import { TranslocoService, TranslocoDirective } from '@jsverse/transloco';
import { ButtonComponent } from '@pedix-workspace/angular-ui-button';
import { DxiValidationRuleModule } from 'devextreme-angular/ui/nested';
import { DxValidatorModule } from 'devextreme-angular/ui/validator';
import { DxSelectBoxModule } from 'devextreme-angular/ui/select-box';
import { CellphoneComponent, TextFieldComponent } from '@pedix-workspace/angular-ui-form';

@Component({
    selector: 'app-step-customer-info',
    templateUrl: './step-customer-info.component.html',
    styleUrls: ['./step-customer-info.component.scss'],
    imports: [
        TranslocoDirective,
        DxValidationGroupModule,
        TextFieldComponent,
        CellphoneComponent,
        DxSelectBoxModule,
        DxValidatorModule,
        DxiValidationRuleModule,
        ButtonComponent,
    ]
})
export class StepCustomerInfoComponent implements OnInit {
  emailPattern = /^[\w.-]+@[\w.-]+\.\w{2,4}$/i;
  phonePattern = /^[0-9+]{8,15}$/i;
  countrySelected: ICountry | undefined;
  discoverySources = [
    { key: 'store_discovery', value: 'Descubrí Pedix en otra tienda' },
    { key: 'friend_recommendation', value: 'Un/a amigo/a me lo recomendó' },
    { key: 'ad_campaign', value: 'Los vi en una campaña publicitaria' },
    { key: 'internet_search', value: 'Encontré Pedix mediante una búsqueda en internet' },
    { key: 'other', value: 'Otro' },
  ];
  @ViewChild('validationGroup') validationGroup: DxValidationGroupComponent;

  private toastrService = inject(ToastrService);
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  public registrationSharedService = inject(RegistrationSharedService);
  private analyticsService = inject(AnalyticsService);
  private t = inject(TranslocoService);
  
  constructor() {}

  ngOnInit() {
    this.analyticsService.startedSubscription()
    this.countrySelected = this.registrationSharedService.getCountrySelected();
  }

  validateStepAndContinue($event) {
    $event.preventDefault();

    if (!this.validationGroup.instance.validate().isValid) {
      this.toastrService.error(this.t.translate('general.error'));
      return;
    }

    this.analyticsService.nextStep('establishment');
    this.router.navigate(['../establishment'], {
      relativeTo: this.activatedRoute,
    });
  }

  prev() {
    document.location.href = '/';
  }

  onEmailChanged(email: string = '') {
    const sanitizedEmail = email.toLowerCase().trim();

    if (this.registrationSharedService.registrationData.customer.email !== sanitizedEmail) {
      this.registrationSharedService.registrationData.customer.email = sanitizedEmail;
    }
  }
}
